import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useContext } from 'react';
import { Link } from 'gatsby';
import { IconButton, VStack } from '@chakra-ui/react';
import { TbBasket } from 'react-icons/tb';
import { StoreContext } from '@interness/ecommerce-addon/src/context/Store';
import { jsx as ___EmotionJSX } from "@emotion/react";
const CartIcon = _ref => {
  let {
    buttonStyle
  } = _ref;
  const {
    cart,
    storeRootPath,
    settings
  } = useContext(StoreContext);
  if (!storeRootPath) {
    return null;
  }
  if (settings.data && settings.data.enable_cart) {
    return ___EmotionJSX(VStack, {
      sx: {
        p: {
          marginTop: '0 !important'
        }
      }
    }, ___EmotionJSX(IconButton, _extends({
      as: Link,
      to: storeRootPath + "/warenkorb",
      size: "lg"
    }, buttonStyle, {
      "aria-label": "Warenkorb (" + cart.totalCount + ")",
      icon: ___EmotionJSX(TbBasket, null)
    })), ___EmotionJSX("p", null, "Warenkorb"));
  } else {
    return null;
  }
};
export default CartIcon;